// App.js - Composant principal
import React, { useState, useEffect } from 'react';



import SidebarADM from '../components/Sidebar/SidebarADM';
import NavbarADM from '../components/Navbar/NavbarADM';
import UserProfile from '../Dashboard/UserProfile';
import EditUserProfile from '../components/Formulaires/EditUserProfile';

function ProfilePageADM({userId, tel}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Détection de la taille d'écran pour le mode mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="app">
      <SidebarADM 
        isOpen={sidebarOpen} 
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <div className="main-content">
        <NavbarADM
          tel={tel}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
      <UserProfile
  userId={userId} 
  onUpdate={(updatedProfile) => {
    console.log('Profil mis à jour:', updatedProfile);
  }} 
/>

 <EditUserProfile
  userId={userId} 
  onUpdate={(updatedProfile) => {
    console.log('Profil mis à jour:', updatedProfile);
  }} 
/>

      </div>
    </div>
  );
}

export default ProfilePageADM;